import { AppConfigModel } from "../abstract/app-config.model";

export class AccountEntryExportFormat extends AppConfigModel {

    static override CLASS_NAME: string = 'AccountEntryExportFormat';

    readonly attachments!: boolean;
}
